import classNames from 'classnames';
import { LazyLoadImage } from 'react-lazy-load-image-component';

import { IWidgetCard } from './types';
import useStyles from './styles';

function WidgetCard({ children, className }: IWidgetCard) {
  const classes = useStyles();

  return (
    <section className={classNames(classes.root, className)}>
      <article className={classes.content}>{children}</article>

      <a className={classes.logo} href="https://tools.picsart.com" target="_blank" rel="noreferrer">
        <LazyLoadImage
          src="https://cdn140.picsart.com/34725934532345634235.svg"
          alt="Quicktools Logo"
        />
      </a>
    </section>
  );
}

export default WidgetCard;
